import SEO from '../components/SEO/SEO'
import ButtonLink from '../components/ButtonLink/ButtonLink'
import Layout from '../layout/Layout'
import classes from '../styles/section.module.css'

const MeetYourNewTeam = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div>
          <div className="relative">
            <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
            <div className="mx-auto">
              <div className="relative">
                <div className="absolute inset-0">
                  <img
                    className="object-cover w-full h-full"
                    src="conferenceroomtalk.png"
                    alt="Team members talking in a conference room"
                  />
                </div>
                <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                  <h1 className="text-3xl tracking-tight md:text-5xl">
                    <span className="block text-blue-dark">
                      Meet your new team.
                    </span>
                    <span className="block text-globeGreen">
                      Because you deserve to be taken care of.
                    </span>
                  </h1>
                  <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-3xl">
                    Our team of compassionate, personalized care guides are
                    at-the-ready to help you navigate the complex healthcare
                    system and support you in your day-to-day health management
                    needs.
                  </p>
                  <a
                    href="https://portal.evryhealth.com/sign-in"
                    rel="noreferrer"
                    target="_blank"
                    className="px-4 py-2 mt-8 bg-white-lighter text-lg text-blue border-2 border-blue hover:bg-blue hover:text-white-light inline-block font-[sans-serif]"
                  >
                    Sign In
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <main>
          <section>
            <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8">
              <div className="grid lg:grid-cols-2 md:gap-16 md:items-center">
                <div className="lg:col-span-1">
                  <h2 className="text-4xl tracking-tight font-extralight">
                    <span className="block text-blue-dark">
                      Healthcare shouldn&lsquo;t be
                    </span>
                    <span className="block text-blue">so confusing.</span>
                  </h2>
                  <p className="max-w-lg mt-6 text-lg text-grey sm:max-w-3xl">
                    With Evry, you&lsquo;ll be paired with your own team of
                    nurses, nutritionists, and doctors who work for you. These
                    medical professionals are the frontline for helping you live
                    a better, healthier, life.
                  </p>
                  <p className="max-w-lg mt-6 text-lg text-grey sm:max-w-3xl">
                    Your Care Coordinator will show you all of the free
                    resources you now have access to with Evry and even how to
                    earn money while helping you focus on an integrated wellness
                    program.
                  </p>
                </div>
                <div className="lg:col-span-1">
                  <div className="flex items-center justify-center h-full pt-10 md:pt-0">
                    <figure
                      className={`${classes.meetYourNewTeamSectionImageRight}`}
                    >
                      <img
                        className="object-cover w-full h-full"
                        src="https://imagedelivery.net/nGYhisqu4x6SCDrz5V8Qxg/0c4b0700-acca-43eb-92d0-1e4e231dfb00/public"
                        alt="Lady smiling"
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white-light">
            <h3 className="text-3xl font-bold text-center uppercase text-blue-dark">
              Here are just a few things they can do for you.
            </h3>
            <div className="grid grid-cols-12 pt-10 text-center">
              <div className="col-span-12 px-0 py-4 md:col-span-6 md:py-16 md:px-32">
                <object
                  className="py-2 mx-auto"
                  data="magnifying-glass.svg"
                  alt="magnifying glass"
                />
                <h4 className="pt-0 text-2xl md:text-3xl text-darkBlue md:pt-8">
                  Throw out the <span className="block">search engines.</span>
                </h4>
                <p className="px-12 py-6 md:px-10 text-grey-dark">
                  Your time is too valuable to decipher a dozen health blogs
                  full of conflicting information. Let our team of experts find
                  you the best answer.
                </p>
              </div>
              <div className="col-span-12 px-0 py-4 md:col-span-6 md:py-16 md:px-32">
                <object
                  className="h-24 py-2 mx-auto md:pt-2 md:pb-6"
                  data="star.svg"
                  alt="map pin"
                />
                <h4 className="pt-4 text-2xl md:text-3xl text-darkBlue">
                  Earn up to <br /> $1,000 per year.
                </h4>
                <p className="px-12 py-6 md:px-10 text-grey-dark">
                  {' '}
                  Evry&lsquo;s activity-based reward program lets you earn
                  rewards in a number of ways ranging from nutrition education
                  to participating with various Evry provided wellness vendors.
                </p>
              </div>
              <div className="col-span-12 px-0 py-8 md:col-span-6 md:py-10 md:px-32">
                <object
                  className="py-2 mx-auto"
                  data="heartbeat.svg"
                  alt="heartbeat"
                />
                <h4 className="text-2xl md:text-3xl text-darkBlue md:pt-6">
                  Get the most out of your{' '}
                  <span className="block">Evry coverage.</span>
                </h4>
                <p className="px-12 py-6 md:px-0 text-grey-dark">
                  Your Evry membership includes a personalized Care Plan that
                  provides unique benefits. Interested in a private trainer?
                  Talk to your Care Guide about Evry paying for it. Need a ride
                  to the doctor? A car is on the way.
                </p>
              </div>
              <div className="col-span-12 px-0 py-8 md:col-span-6 md:py-6 md:px-32">
                <object
                  className="py-4 mx-auto"
                  data="calendar-blue.svg"
                  alt="calendar icon"
                />
                <h4 className="text-2xl md:text-3xl text-darkBlue md:pt-6">
                  Stop stressing about
                  <span className="block">appointments.</span>
                </h4>
                <p className="px-12 py-6 md:px-0 text-grey-dark">
                  From routine office visits to complicated procedures,
                  we&lsquo;ll help you prepare for it and get you ready for
                  gameday. We enjoy the soft jazz of hold music, so that you
                  don&lsquo;t have to.
                </p>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  )
}

export default MeetYourNewTeam
